import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import Tooltip from '../tooltip/tooltip';
import { dataHooks, MEASURE_STYLE, RELEVANT_STYLE_PROPERTIES } from './constants';
var PIXELS_TO_REDUCE = 30; // ment to prevent a situation where ellipsis activated without showing tooltip

var isTextOverflown = function isTextOverflown(element, measureElement, maxLines) {
  var measureElementWidth = measureElement.getBoundingClientRect().width;
  var elmWidth = element === measureElement || window.getComputedStyle(element).display === 'inline' ? element.parentElement.getBoundingClientRect().width : element.getBoundingClientRect().width;
  var containerWidth = Number(elmWidth.toFixed(2));
  var contentWidth = Number(measureElementWidth.toFixed(2));
  if (maxLines && maxLines !== 1) {
    // mutiple container size by number of lines, and decrease the container width by 60px times the number of lines
    var decreasBy = maxLines * PIXELS_TO_REDUCE;
    containerWidth = containerWidth * maxLines - decreasBy;
  }
  return contentWidth > containerWidth;
};
var isEqual = function isEqual(curStyle, newStyle) {
  return _.every(RELEVANT_STYLE_PROPERTIES, function (property) {
    return curStyle[property] === newStyle[property];
  });
};
var hasTextLabel = function hasTextLabel(props) {
  return _.includes([displayNames.TEXT_LABEL, displayNames.TEXT_LABEL_BASE], _.invoke(props, 'children.type.getDisplayName'));
};
var getLabelContent = function getLabelContent(props) {
  return _.get(props, 'children.props.shouldTranslate') ? props.translateIfNeeded(_.get(props, 'children.props.value')) : _.get(props, 'children.props.value');
};
var isAncestor = function isAncestor(child, parent) {
  var curNode = child;
  while (curNode.parentElement !== null) {
    if (curNode.parentElement === parent) {
      return true;
    }
    curNode = curNode.parentElement;
  }
  return false;
};
var isElementWithKey = function isElementWithKey(element) {
  return /*#__PURE__*/React.isValidElement(element) && element.key !== null;
};
var DEFAULT_STATE = {
  displayTooltip: false,
  style: MEASURE_STYLE
};
var TooltipOnEllipsis = /*#__PURE__*/function (_React$Component) {
  function TooltipOnEllipsis(props) {
    var _this;
    _classCallCheck(this, TooltipOnEllipsis);
    _this = _callSuper(this, TooltipOnEllipsis, [props]);
    _this.state = DEFAULT_STATE;
    _this.getContentContainerRef = function (ref) {
      _this.contentContainerRef = ref;
    };
    _this.getMeasureContainerRef = function (ref) {
      _this.measureContainerRef = ref;
    };
    _this.getContent = function () {
      return hasTextLabel(_this.props) ? getLabelContent(_this.props) : _.get(_this, 'props.children.props', _this.props).children;
    };
    _this.getTooltipMessage = function () {
      return _this.props.customTooltipMessage || _this.getContent();
    };
    _this.getMeasureNode = function () {
      return _this.measureContainerRef.firstElementChild || _this.measureContainerRef;
    };
    _this.isDisabled = function () {
      return _this.props.disabled || !_this.state.displayTooltip;
    };
    _this.getMaxLines = function () {
      var maxLines = _this.props.maxLines;
      return maxLines > 1 ? maxLines : 1;
    };
    _this.getClassName = function () {
      var maxLinesClassName = _this.getMaxLines() > 1 ? 'multiLine' : 'singleLine';
      return "".concat(_this.props.getClassName('tooltip-on-ellipsis-content', 'contentClassName'), " ").concat(maxLinesClassName);
    };
    _this.onMouseEnter = function () {
      var newStyle = _this.getStyle();
      if (isEqual(_this.state.style, newStyle)) {
        _this.calcEllipsis();
      } else {
        _this.setState({
          style: newStyle
        }, _this.calcEllipsis);
      }
    };
    _this.calcEllipsis = function () {
      var displayTooltip = isTextOverflown(_this.getTextNode(), _this.getMeasureNode(), _this.getMaxLines());
      if (_this.state.displayTooltip !== displayTooltip) {
        _this.setState({
          displayTooltip: displayTooltip
        });
      }
    };
    _this.getTextNode = function () {
      return _.get(_this, 'contentContainerRef.firstElementChild', _this.contentContainerRef);
    };
    _this.getStyle = function () {
      var textChild = _this.getTextNode();
      if (!textChild) {
        return MEASURE_STYLE;
      }
      return _(textChild).thru(window.getComputedStyle).pick(RELEVANT_STYLE_PROPERTIES).pickBy(_.negate(_.isUndefined)).assign({}, MEASURE_STYLE).value();
    };
    return _this;
  }
  _inherits(TooltipOnEllipsis, _React$Component);
  return _createClass(TooltipOnEllipsis, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.customTrigger) {
        var thisNode = ReactDOM.findDOMNode(this);
        var customTriggerNode = ReactDOM.findDOMNode(this.props.customTrigger);
        if (!isAncestor(thisNode, customTriggerNode)) {
          throw new Error("this.props.customTrigger (".concat(customTriggerNode, ") is not an ancestor of this (tooltipOnEllipsis)"));
        }
        customTriggerNode.addEventListener('mouseenter', this.onMouseEnter);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.customTrigger) {
        var customTriggerNode = ReactDOM.findDOMNode(this.props.customTrigger);
        customTriggerNode.removeEventListener('mouseenter', this.onMouseEnter);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var shouldCompareKeys = isElementWithKey(nextProps.children) && isElementWithKey(this.props.children);
      var shouldCloseTooltip = shouldCompareKeys && this.props.children.key !== nextProps.children.key || !shouldCompareKeys && nextProps.children !== this.props.children;
      if (shouldCloseTooltip) {
        this.setState(DEFAULT_STATE);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var maxLines = this.getMaxLines();
      var maxLinesCSS = maxLines > 1 ? {
        '--maxLines': maxLines
      } : {};
      return /*#__PURE__*/React.createElement(Tooltip, {
        alignment: this.props.alignment,
        animationDuration: this.props.animationDuration,
        arrowDistance: this.props.arrowDistance,
        closeOnMouseLeave: this.props.closeOnMouseLeave,
        closeOnMouseClick: this.props.closeOnMouseClick,
        content: this.getTooltipMessage(),
        customTrigger: this.props.customTrigger,
        automationId: this.props.automationId,
        dataHook: this.props.dataHook,
        direction: this.props.direction,
        disabled: this.isDisabled(),
        displayCustomTrigger: this.props.displayCustomTrigger,
        isHint: this.props.isHint,
        isOpen: this.props.isOpen,
        maxWidth: this.props.maxWidth,
        marginTop: this.props.marginTop,
        marginRight: this.props.marginRight,
        marginBottom: this.props.marginBottom,
        marginLeft: this.props.marginLeft,
        openOnMouseEnter: this.props.openOnMouseEnter,
        onScroll: this.props.onScroll,
        onOpen: this.props.onOpen,
        onClose: this.props.onClose,
        onOuterClick: this.props.onOuterClick,
        shouldTranslate: false,
        zIndex: this.props.zIndex
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.getContentContainerRef,
        className: this.getClassName(),
        style: maxLinesCSS,
        onMouseEnter: this.props.customTrigger ? null : this.onMouseEnter,
        "data-hook": dataHooks.contentContainer
      }, this.props.children, /*#__PURE__*/React.createElement("span", {
        ref: this.getMeasureContainerRef,
        style: this.state.style,
        className: "tooltip-on-ellipsis-content-measure",
        "data-hook": dataHooks.content
      }, this.getContent())));
    }
  }]);
}(React.Component);
TooltipOnEllipsis.displayName = displayNames.TOOLTIP_ON_ELLIPSIS;
TooltipOnEllipsis.propTypes = {
  /** align the tooltip: 'TOP','BOTTOM','LEFT' or 'RIGHT' */
  alignment: PropTypes.oneOf(['TOP', 'BOTTOM', 'LEFT', 'RIGHT']),
  /** the duration for the tooltip to be close. triggered only after hovering the content itself*/
  animationDuration: PropTypes.number,
  /** the tooltip arrow distance from it */
  arrowDistance: PropTypes.number,
  /** should close tooltip on clicking attached component */
  closeOnMouseClick: PropTypes.bool,
  /** should close tooltip on mouse leave */
  closeOnMouseLeave: PropTypes.bool,
  contentClassName: PropTypes.string,
  customTrigger: PropTypes.object,
  // React ref

  customTooltipMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.element]),
  direction: PropTypes.string,
  /** disables tooltip appearance */
  disabled: PropTypes.bool,
  displayCustomTrigger: PropTypes.bool,
  /** show tooltip as hint (responsive only) */
  isHint: PropTypes.bool,
  /** is tooltip open */
  isOpen: PropTypes.bool,
  /** the bottom margin from the tooltip to its child/attached component */
  marginBottom: PropTypes.number,
  /** the left margin from the tooltip to its child/attached component */
  marginLeft: PropTypes.number,
  /** the right margin from the tooltip to its child/attached component */
  marginRight: PropTypes.number,
  /** the top margin from the tooltip to its child/attached component */
  marginTop: PropTypes.number,
  /** tooltip max content width */
  maxWidth: PropTypes.number,
  /** a callback to called on tooltip closed */
  onClose: PropTypes.func,
  /** a callback to called on tooltip opended */
  onOpen: PropTypes.func,
  /** a callback to called on click outside the tooltip */
  onOuterClick: PropTypes.func,
  /** a callback to called on page scroll */
  onScroll: PropTypes.func,
  /** show tooltip on mouse enter the attached component */
  openOnMouseEnter: PropTypes.bool,
  /** tooltip z index */
  zIndex: PropTypes.number,
  /** the number of lines displayed before the text is truncated. default is one line. */
  maxLines: PropTypes.number
};
export default compose(TooltipOnEllipsis);